"use strict";

/**
 * @ngdoc directive
 * @name izzyposWebApp.directive:adminPosHeader
 * @description
 * # adminPosHeader
 */

(function () {
  "use strict";
  angular.module("myApp").directive("jobAlerts", jobAlerts);

  function jobAlerts() {
    var directiveObj = {};
    directiveObj.bindToController = true;
    directiveObj.controller = JobsCtrl;
    directiveObj.controllerAs = "jobsCtrl";
    directiveObj.templateUrl =
      "js/scripts/directives/job-alerts/job-alerts.html";
    directiveObj.restrict = "E";
    directiveObj.replace = true;
    return directiveObj;
  }

  function JobsCtrl($scope, apiService, $localStorage, $state, userService) {
    var jobsCtrl = this;
    jobsCtrl.loading = false;
    jobsCtrl.nurseNotificationsCount = 0;
    jobsCtrl.getNotifications = getNotifications;
    jobsCtrl.removeNotification = removeNotification;
    jobsCtrl.redirectToTab = redirectToTab;
    jobsCtrl.notifications = [];

    if ($localStorage["token"]) {
      jobsCtrl.getNotifications("JOB_ALERTS");
    }

    /*iniitially for jobs only. Re-purposed to also redirect to tasks.
     * App notification system also needs to be reviewed to use appropriate notification type.
     */
    function redirectToTab(notification) {
      if (notification?.type === "GENERAL_ALERT") {
        $state.go("dashboard.tasks");
      } else {
        $state.go("dashboard.jobs");
      }
    }

    function getNotifications(notificationType) {
      jobsCtrl.loading = true;
      userService
        .listNotifications($localStorage["token"], { notificationType })
        .then((response) => {
          jobsCtrl.loading = false;
          if (response) {
            jobsCtrl.notifications = response.list;
            jobsCtrl.nurseNotificationsCount = response.count;
          }
        })
        .catch(() => (jobsCtrl.loading = false))
        .finally(() => $scope.$apply());
    }

    function removeNotification(index) {
      jobsCtrl.notifications.splice(index, 1);
    }

    $scope.$on("newNotification", function (event, args) {
      jobsCtrl.getNotifications("JOB_ALERTS");
    });
  }
})();
